const colors = {
  blue: "rgb(51, 153, 254)",
  black: "#2c303b",
  red: "#E60B2F",
};

export default colors;
